import { Button } from '@nextui-org/react'
import React from 'react'
import { FiThumbsUp, FiThumbsDown } from 'react-icons/fi'

import { array, bool, func } from 'prop-types'
import * as s from './TinderBtns.styles'

const sizeMainBtns = 26
const sizeSecondaryBtns = 15

const propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  offers: array,
  canGoBack: bool.isRequired,
  goBack: func.isRequired,
  swipe: func.isRequired,
}

const defaultProps = {
  offers: [],
}

const TinderBtns = ({ offers, canGoBack, goBack, swipe, mutating }) => (
  <s.TinderBtnsWrapper>
    <div className="btn-container">
      <Button
        color="primary"
        onClick={() => {
          swipe('left')
        }}
        ghost
        style={{ width: '100%' }}
      >
        <FiThumbsDown size={20} style={{ marginRight: 10 }} />
        Non, merci
      </Button>

      <Button
        color="primary"
        disabled={offers.length === 0 || mutating}
        onClick={() => {
          swipe('right')
        }}
        style={{ width: '100%', backgroundColor: '#081339' }}
      >
        <FiThumbsUp size={20} style={{ marginRight: 10 }} />
        Je postule
      </Button>
    </div>
    {/* <Button
      tabIndex={0}
      className="go-back"
      disabled={!canGoBack || mutating}
      onClick={goBack}
      style={{ opacity: canGoBack ? 1 : 0.4 }}
    >
      <RiArrowGoBackLine size={sizeSecondaryBtns} color="black" />
    </Button> */}
  </s.TinderBtnsWrapper>
)

TinderBtns.propTypes = propTypes
TinderBtns.defaultProps = defaultProps
export default TinderBtns
